/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * Session ID for the user
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    sessionId?: string;
    /**
     * User ID
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    uid: string;
}

/**
 * Check if a given object implements the RefreshTokenRequest interface.
 */
export function instanceOfRefreshTokenRequest(value: object): value is RefreshTokenRequest {
    if (!('uid' in value) || value['uid'] === undefined) return false;
    return true;
}

export function RefreshTokenRequestFromJSON(json: any): RefreshTokenRequest {
    return RefreshTokenRequestFromJSONTyped(json, false);
}

export function RefreshTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'uid': json['uid'],
    };
}

export function RefreshTokenRequestToJSON(json: any): RefreshTokenRequest {
    return RefreshTokenRequestToJSONTyped(json, false);
}

export function RefreshTokenRequestToJSONTyped(value?: RefreshTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'uid': value['uid'],
    };
}

